import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Power Bank",
        price: 40,
        disprice: 30,
        stock: 10,
        content: "Portable and lightweight power bank to charge your devices anytime, anywhere—perfect for travel or daily use.",
        description: "Stay powered on the go with our reliable Power Bank. Featuring a high-capacity battery, multiple USB ports, and fast-charging capabilities. Compact and durable, it’s an essential gadget for your smartphone, tablet, or wearable devices. Whether you’re commuting, traveling, or working remotely, never run out of charge.",
        category: ["Mobile Accessories", "Home Electronics"],
        tags: ["portable", "charging", "battery"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Capacity", content: "10000mAh" },
            { id: 2, title: "Output Ports", content: "2 USB-A, 1 USB-C" },
            { id: 3, title: "Charging Time", content: "3-4 hours" },
            { id: 4, title: "Compatibility", content: "Smartphones, Tablets, Wearables" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Alex Johnson",
                date: "June 10, 2025",
                rating: 5,
                content: "Excellent battery life and fast charging. A must-have for travel!"
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Samantha Lee",
                date: "June 12, 2025",
                rating: 4.5,
                content: "Compact and easy to carry. Charges my phone multiple times."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Smart Speakers",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Voice-activated smart speakers with immersive sound and AI-powered assistants—perfect for smart homes and entertainment.",
        description: "Elevate your home experience with Smart Speakers. Featuring high-fidelity sound, voice control, and smart assistant integration (Alexa, Google Assistant). Easily stream music, control smart devices, and get real-time updates. A sleek and modern addition to your living room, kitchen, or workspace.",
        category: ["Smart Devices", "Home Electronics"],
        tags: ["smart", "audio", "wireless"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Connectivity", content: "Wi-Fi, Bluetooth" },
            { id: 2, title: "Voice Assistants", content: "Supports Alexa, Google Assistant" },
            { id: 3, title: "Playback Time", content: "Up to 10 hours" },
            { id: 4, title: "Audio Output", content: "360° Surround Sound" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Chris Evans",
                date: "July 1, 2025",
                rating: 5,
                content: "Crystal clear sound and easy voice commands. Love using it for my daily routine!"
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Olivia Brown",
                date: "July 3, 2025",
                rating: 4.5,
                content: "Works great with my smart home devices. Setup was super easy."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Laptops",
        price: 1200,
        disprice: 999,
        stock: 3,
        content: "High-performance laptops designed for work, gaming, and creativity with powerful processors and sleek designs.",
        description: "Our Laptops deliver exceptional performance for professionals, gamers, and creators alike. Equipped with the latest processors, vibrant displays, and long-lasting batteries. Ideal for multitasking, video editing, or immersive gaming sessions. Experience seamless productivity and entertainment wherever you go.",
        category: ["Smart Devices", "Office Equipment"],
        tags: ["computing", "office", "portable"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Processor", content: "Intel Core i7 / AMD Ryzen 7" },
            { id: 2, title: "Storage", content: "512GB SSD" },
            { id: 3, title: "Display", content: "15.6-inch Full HD" },
            { id: 4, title: "Battery Life", content: "Up to 12 hours" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Daniel Reed",
                date: "July 6, 2025",
                rating: 5,
                content: "Super fast performance and great battery backup. Perfect for my design work!"
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Sophia Lee",
                date: "July 7, 2025",
                rating: 4.5,
                content: "Very sleek and lightweight. Handles my gaming and work effortlessly."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Keyboards",
        price: 70,
        disprice: 55,
        stock: 0,
        content: "Ergonomic and responsive keyboards ideal for typing, gaming, and professional use.",
        description: "Our Keyboards are crafted for comfort and precision, featuring ergonomic designs, tactile key switches, and customizable lighting options. Perfect for both office work and intense gaming sessions. Built for durability and ease of use across various devices.",
        category: ["Computer Peripherals", "Office Equipment"],
        tags: ["computing", "office", "accessories"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Type", content: "Mechanical / Membrane" },
            { id: 2, title: "Connectivity", content: "Wired & Wireless Options" },
            { id: 3, title: "Backlight", content: "RGB Customizable" },
            { id: 4, title: "Compatibility", content: "Windows, MacOS, Linux" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Ava Mitchell",
                date: "July 8, 2025",
                rating: 5,
                content: "Great feel while typing. The backlight options are amazing!"
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Lucas Brown",
                date: "July 9, 2025",
                rating: 4.5,
                content: "Perfect for my home office. Keys are soft and responsive."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Wireless Mouse",
        price: 30,
        disprice: 22,
        stock: 9,
        content: "Smooth and responsive wireless mouse designed for productivity and gaming with ergonomic comfort.",
        description: "Our Wireless Mouse offers seamless connectivity, precise tracking, and ergonomic comfort for long hours of use. Featuring adjustable DPI, silent clicks, and a rechargeable battery, it's perfect for both professional workspaces and gaming setups.",
        category: ["Computer Peripherals", "Mobile Accessories"],
        tags: ["wireless", "computing", "accessories"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "DPI Range", content: "800 – 3200 DPI" },
            { id: 2, title: "Battery Life", content: "Up to 60 days per charge" },
            { id: 3, title: "Connectivity", content: "Bluetooth & USB Receiver" },
            { id: 4, title: "Compatibility", content: "Windows, MacOS, Linux" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Olivia Turner",
                date: "July 10, 2025",
                rating: 5,
                content: "Very smooth and fits perfectly in hand. No lag during usage."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Ethan Scott",
                date: "July 11, 2025",
                rating: 4.5,
                content: "Battery lasts long and works seamlessly with my laptop."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Wireless Charger",
        price: 35,
        disprice: 25,
        stock: 5,
        content: "Fast and convenient wireless charger compatible with smartphones, earbuds, and smartwatches.",
        description: "Our Wireless Charger provides fast, reliable charging without the clutter of cables. Designed for Qi-enabled devices, it features intelligent charging control, overheat protection, and a sleek, minimal design—perfect for your desk or nightstand.",
        category: ["Mobile Accessories", "Home Electronics"],
        tags: ["wireless", "charging", "accessories"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Charging Speed", content: "Up to 15W Fast Charge" },
            { id: 2, title: "Compatibility", content: "Qi-enabled Devices" },
            { id: 3, title: "Safety Features", content: "Overheat & Overcharge Protection" },
            { id: 4, title: "Material", content: "Aluminum + Silicone Base" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Sophia Reed",
                date: "July 12, 2025",
                rating: 5,
                content: "Charges my phone and earbuds quickly without heating up."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Liam Cooper",
                date: "July 13, 2025",
                rating: 4.8,
                content: "Compact and stylish design. Works perfectly on my nightstand."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Laser Printer",
        price: 180,
        disprice: 150,
        stock: 2,
        content: "High-speed laser printer delivering crisp, professional-quality prints for home and office use.",
        description: "Our Laser Printer offers fast printing speeds and sharp text clarity for documents, reports, and graphics. With wireless connectivity, duplex printing, and energy-saving modes, it's ideal for busy environments where quality and efficiency matter.",
        category: ["Office Equipment", "Home Electronics"],
        tags: ["office", "printing", "computing"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Print Speed", content: "Up to 30 ppm" },
            { id: 2, title: "Connectivity", content: "Wi-Fi, USB, Ethernet" },
            { id: 3, title: "Functions", content: "Print, Scan, Copy" },
            { id: 4, title: "Paper Capacity", content: "250-sheet Tray" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Michael Grant",
                date: "July 14, 2025",
                rating: 4.7,
                content: "Fast and reliable. Great for my home office setup."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Olivia Chen",
                date: "July 15, 2025",
                rating: 4.9,
                content: "Sharp print quality and easy wireless setup."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Desktop PC",
        price: 750,
        disprice: 680,
        stock: 0,
        content: "Powerful desktop PC built for work, gaming, and entertainment with fast processors and ample storage.",
        description: "This Desktop PC features the latest processors, high-speed memory, and large storage options to handle multitasking, gaming, and creative work with ease. Equipped with multiple ports, sleek design, and efficient cooling to ensure optimal performance all day long.",
        category: ["Smart Devices", "Office Equipment"],
        tags: ["computing", "office", "thermal"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Processor", content: "Intel Core i7 12th Gen" },
            { id: 2, title: "Memory", content: "16GB DDR4 RAM" },
            { id: 3, title: "Storage", content: "512GB SSD + 1TB HDD" },
            { id: 4, title: "Graphics", content: "NVIDIA GeForce RTX 4060" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Daniel Reed",
                date: "July 16, 2025",
                rating: 4.8,
                content: "Handles my design software and games effortlessly. Very satisfied!"
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Samantha Lee",
                date: "July 17, 2025",
                rating: 5,
                content: "Great all-around desktop for work and play. Highly recommend!"
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Smart Thermostat",
        price: 120,
        disprice: 99,
        stock: 9,
        content: "Energy-efficient smart thermostat that optimizes your home’s heating and cooling automatically.",
        description: "The Smart Thermostat helps you maintain a comfortable home environment while saving energy. With intuitive controls, Wi-Fi connectivity, and app integration, you can adjust temperature settings remotely. Compatible with most HVAC systems for easy installation and usage.",
        category: ["Smart Devices", "Home Electronics"],
        tags: ["smart", "thermal", "office"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Compatibility", content: "Supports most HVAC systems" },
            { id: 2, title: "Connectivity", content: "Wi-Fi, Mobile App Control" },
            { id: 3, title: "Energy Savings", content: "Up to 23% energy savings annually" },
            { id: 4, title: "Installation", content: "Easy DIY or professional setup" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Olivia Bennett",
                date: "July 19, 2025",
                rating: 5,
                content: "Love the convenience and savings! Adjusting the temperature from my phone is a game changer."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Ethan Cooper",
                date: "July 20, 2025",
                rating: 4.7,
                content: "Installation was easy and it works flawlessly with my home system."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Portable Charger",
        price: 35,
        disprice: 28,
        stock: 6,
        content: "Compact and reliable portable charger to keep your devices powered on the go.",
        description: "Stay charged wherever you are with our Portable Charger. Lightweight and powerful, it supports fast charging for smartphones, tablets, and other USB-powered devices. Ideal for travel, work, or daily use with long-lasting battery capacity and multiple charging ports.",
        category: ["Mobile Accessories", "Smart Devices"],
        tags: ["portable", "charging", "accessories"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Battery Capacity", content: "10000mAh" },
            { id: 2, title: "Charging Ports", content: "Dual USB Output" },
            { id: 3, title: "Charging Time", content: "4-5 hours" },
            { id: 4, title: "Compatibility", content: "Supports most smartphones & tablets" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Sophia Lee",
                date: "July 22, 2025",
                rating: 5,
                content: "Perfect size for my bag and charges my phone quickly. Highly recommend!"
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Michael Chen",
                date: "July 23, 2025",
                rating: 4.8,
                content: "Reliable backup power source during travel. Fast and efficient."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Voice Speakers",
        price: 45,
        disprice: 38,
        stock: 4,
        content: "Crystal-clear voice-enabled speakers that deliver immersive sound and smart home integration.",
        description: "Our Voice Speakers combine premium audio with smart assistant functionality. Enjoy rich bass, clear treble, and hands-free control of your music, smart devices, and information queries. Perfect for modern homes, offices, and entertainment spaces.",
        category: ["Smart Devices", "Home Electronics"],
        tags: ["audio", "wireless", "smart"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Connectivity", content: "Wi-Fi & Bluetooth" },
            { id: 2, title: "Voice Assistant", content: "Compatible with Alexa & Google Assistant" },
            { id: 3, title: "Audio Output", content: "360° Surround Sound" },
            { id: 4, title: "Power Source", content: "AC Adapter" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Alex Morgan",
                date: "July 24, 2025",
                rating: 5,
                content: "Excellent sound quality and integrates perfectly with my smart home setup."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Sara Ahmed",
                date: "July 25, 2025",
                rating: 4.7,
                content: "The voice commands work flawlessly. Great addition to my living room."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Notebook Computers",
        price: 750,
        disprice: 680,
        stock: 0,
        content: "Portable notebook computers designed for productivity and entertainment on the go.",
        description: "Our Notebook Computers feature sleek designs, fast processors, and vibrant displays. Ideal for work, study, or play, they offer powerful performance, long battery life, and seamless connectivity. Customize your experience with various storage and memory options.",
        category: ["Smart Devices", "Office Equipment"],
        tags: ["computing", "portable", "office"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Processor", content: "Intel Core i5 / i7" },
            { id: 2, title: "Memory", content: "8GB / 16GB RAM" },
            { id: 3, title: "Storage", content: "256GB / 512GB SSD" },
            { id: 4, title: "Battery Life", content: "Up to 10 hours" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Daniel Green",
                date: "July 26, 2025",
                rating: 5,
                content: "Perfect for my remote work needs. Lightweight yet powerful."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Maya Lee",
                date: "July 27, 2025",
                rating: 4.8,
                content: "Great display and battery life. I use it for both study and entertainment."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Typing Keyboards",
        price: 45,
        disprice: 35,
        stock: 28,
        content: "Comfortable and responsive typing keyboards ideal for work, gaming, and daily use.",
        description: "Our Typing Keyboards offer ergonomic designs, tactile feedback, and quiet keystrokes. Whether for office work, gaming, or casual use, they enhance your typing comfort and speed. Available in wired and wireless options with customizable key layouts and backlighting.",
        category: ["Computer Peripherals", "Office Equipment"],
        tags: ["computing", "accessories", "office"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Connection Type", content: "Wired / Wireless" },
            { id: 2, title: "Key Type", content: "Mechanical / Membrane" },
            { id: 3, title: "Backlighting", content: "RGB / Single Color" },
            { id: 4, title: "Compatibility", content: "Windows, macOS, Linux" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Olivia Brooks",
                date: "July 28, 2025",
                rating: 5,
                content: "Smooth typing experience and great build quality. Highly recommend!"
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Liam Foster",
                date: "July 29, 2025",
                rating: 4.7,
                content: "Very comfortable for long typing sessions. The wireless option is a plus."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Cordless Mouse",
        price: 25,
        disprice: 18,
        stock: 40,
        content: "Smooth and precise cordless mouse, designed for seamless navigation and productivity.",
        description: "Our Cordless Mouse offers wireless convenience with precise optical tracking. Featuring ergonomic design, adjustable DPI, and long battery life, it’s ideal for everyday computing, gaming, and professional work environments. Compatible with Windows, macOS, and more.",
        category: ["Computer Peripherals", "Mobile Accessories"],
        tags: ["wireless", "accessories", "computing"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Connection Type", content: "Wireless (USB Receiver / Bluetooth)" },
            { id: 2, title: "Sensor Type", content: "Optical" },
            { id: 3, title: "Battery Life", content: "Up to 12 months" },
            { id: 4, title: "Compatibility", content: "Windows, macOS, Linux" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Sophia Adams",
                date: "August 1, 2025",
                rating: 5,
                content: "Very responsive and fits perfectly in hand. Great value for money!"
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Noah Williams",
                date: "August 3, 2025",
                rating: 4.8,
                content: "Setup was quick and easy. Battery lasts really long!"
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Wireless Dock",
        price: 65,
        disprice: 50,
        stock: 20,
        content: "Versatile wireless dock for seamless charging and connectivity across your devices.",
        description: "The Wireless Dock simplifies your workspace by combining wireless charging with multiple connectivity ports. Charge your phone, connect peripherals, and transfer data wirelessly or via USB-C, HDMI, and more. Designed for convenience at home or the office.",
        category: ["Computer Peripherals", "Mobile Accessories"],
        tags: ["wireless", "charging", "accessories"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Charging Power", content: "Up to 15W Wireless Charging" },
            { id: 2, title: "Ports", content: "USB-C, HDMI, USB-A, Ethernet" },
            { id: 3, title: "Compatibility", content: "iOS, Android, Windows, macOS" },
            { id: 4, title: "Wireless Range", content: "Up to 10 meters" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Ethan Brooks",
                date: "August 8, 2025",
                rating: 4.7,
                content: "Neat little device that cleared up my desk space. Works flawlessly."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Olivia Bennett",
                date: "August 9, 2025",
                rating: 4.9,
                content: "Charges my phone fast and connects all my peripherals with ease."
            }
        ]
    },

];

export default products;